import { Show } from "shared/components";
import { OtherLeadsRecordedNote } from "shared/app/EmailUnsubscribes/OtherLeadsRecordedNote";
import { LeadActivity } from "views/leads-id/types";

export const EmailSubscriptionDescription = ({
  activity
}: {
  activity: LeadActivity;
}) => (
  <div className="space-y-1 text-sm text-content-400">
    <Show if={Boolean(activity.description)}>
      <p>{activity.description}</p>
    </Show>
    <OtherLeadsRecordedNote leadIds={activity.metadata.other_lead_ids} />
  </div>
);
